import {i18n as i18nType} from 'i18next';

import {Country, PackagingFormatType} from 'types/gtins';

export const handleValuesFromExternalDictionary = (
    key: string,
    item: string,
    i18n: i18nType,
    packagingFormatTypeDictionary: PackagingFormatType[],
    profileCountries: Country[],
) => {
    if (key === 'country_manufacture') {
        return (
            profileCountries.find((i) => {
                const keyByLanguage = i18n.language === 'en' ? i.country : i.countryFr ?? i.country;
                return keyByLanguage?.toLowerCase() === item.toLowerCase();
            })?.code || item
        );
    }

    const packagingType = packagingFormatTypeDictionary.find(
        (i) => i.name.toLowerCase() === item.toLowerCase(),
    );

    if (packagingType) {
        return packagingType.code;
    }
    return item;
};

enum GetDataByLanguageKeys {
    translation = 'translation',
    dictionaries = 'dictionaries',
}

const getNestedValue = (obj: any, path: string): any =>
    path.split('.').reduce((current, key) => current?.[key], obj);

export const handleValuesFromInternalDictionary = (
    key: string,
    item: string,
    i18n: i18nType,
    dictionariesFields: Record<string, string>,
) => {
    const dictionaries = i18n.getDataByLanguage(i18n.language)?.[
        GetDataByLanguageKeys.translation
    ]?.[GetDataByLanguageKeys.dictionaries] as Record<string, string> | undefined;

    if (!dictionaries) return item;

    const dictionary = getNestedValue(dictionaries, dictionariesFields[key]);

    const KEY_INDEX = 0;
    if (dictionary && typeof dictionary === 'object') {
        const foundItem = Object.entries(dictionary)?.find(
            ([_key, value]) => (value as string).toLowerCase() === item.toLowerCase(),
        );

        return foundItem ? foundItem[KEY_INDEX] : item;
    }

    return item;
};
